"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonBadge = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _Badge = require("../../../shared/Badge");
const getBadgeMinWidth = buttonSize => {
  return buttonSize.includes("small") ? 1 : 5;
};
const getBadgeOffset = buttonSize => {
  switch (buttonSize) {
    case "small":
    case "xsmall":
      return "-5.5px";
    case "medium":
    case "large":
    default:
      return "-7.5px";
  }
};
const ButtonBadge = (0, _styled.default)(_Badge.Badge)`
    top: ${_ref => {
  let {
    buttonSize
  } = _ref;
  return getBadgeOffset(buttonSize);
}};
    right: ${_ref2 => {
  let {
    buttonSize
  } = _ref2;
  return getBadgeOffset(buttonSize);
}};
    // these next two numbers differ from figma because of the .5px padding figma gives to text
    border-radius: 7px;
    padding: 0px 3.5px;
    border-width: 1px;
    min-width: ${_ref3 => {
  let {
    buttonSize
  } = _ref3;
  return getBadgeMinWidth(buttonSize);
}}px;
`;
exports.ButtonBadge = ButtonBadge;
//# sourceMappingURL=ButtonBadge.js.map